import classNames from "classnames";
import React from "react";
import * as zenscroll from "zenscroll";
import { isServer } from "../../utils/detection";
import { ShowMoreButton } from "../../misc/ShowMoreButton/ShowMoreButton";

import "./ShowMoreHeightFade.scss";

interface Props {
  threshold?: number;
  className?: string;
  onOpen?: () => void;
  hideShowLess?: boolean;
}

interface State {
  canShowMore?: boolean;
  isOpen?: boolean;
}

/**
 * Wraps text and displays a show more button if the text length exceeds the threshold
 *
 * Should be reviewed to be hooks based at some point
 *
 * @status review
 */
export class ShowMoreHeightFade extends React.Component<Props, State> {
  private container: HTMLDivElement | null;

  constructor(props: Props) {
    super(props);
    this.state = {
      canShowMore: false,
      isOpen: isServer(),
    };
    this.container = null;
  }

  public defaultProps: Props = {
    threshold: 96, // 6rem
  };

  private toggleOpen = () => {
    const willBeOpen = !this.state.isOpen;
    this.setState({ isOpen: willBeOpen }, () => {
      if (willBeOpen) {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
      else {
        if (this.container != null) {
          // Keep in view when closing
          zenscroll.intoView(this.container as HTMLElement, 0);
        }
      }
    });
  }

  public componentDidMount() {
    if (isServer()) {
      return; // Let the bots see everything
    }

    // overflow:hidden means container height == body height
    // It's likely that if this is the case, there's more content to show
    const fuzz = 2;
    if (
      this.container?.clientHeight
      && this.props?.threshold
      && (this.container.clientHeight + fuzz >= this.props.threshold)
    ) {
      this.setState({ canShowMore: true });
    }
  }

  public render() {
    const {
      isOpen,
      canShowMore,
    } = this.state;

    const {
      className,
      threshold,
      children,
      hideShowLess,
    } = this.props;

    const parentClasses = classNames(
      { "show-more-open": isOpen },
      { "show-more-closed": canShowMore && !isOpen },
    );
    const bodyStyle: React.CSSProperties = {
      maxHeight: isOpen ? undefined : threshold,
    };

    const hide = !!(isOpen && hideShowLess);

    return (
      <div className={classNames("show-more-fadeable", parentClasses, className)}>
        <div ref={d => this.container = d} className="show-more-body" style={bodyStyle}>
          {children}
        </div>

        {!hide && canShowMore && (
          <ShowMoreButton onClick={this.toggleOpen} isOpen={!!isOpen} />
        )}
      </div>
    );
  }
}
